import Vue from 'vue';

import downloadWindow from '../../../modules/download/containers/download-window/download-window.container';

export class Download {
    visible: false;
    instance;

    create () {
        if (this.instance && this.instance.$refs.widget.visible) {
            return;
        }

        const el = document.createElement('div');

        this.instance = new Vue({
            el,
            components: {
                downloadWindow
            },
            template: `
                <download-window
                    ref="widget"
                    @submit="onSubmit($event)"
                    @close="onCancel()"/>
                </download-window>
            `
        });
    }
}



// WEBPACK FOOTER //
// ./src/scripts/core/download/index.js